import type { ScaleLinear } from 'd3-scale';
import { useContext, createContext } from 'react';

import type { DataTableV2GanttColumnConfig } from '../../../tables/DataTableV2/features/ColumnTypes/ColumnTypes.js';
import type { GanttSegmentData } from '../types/gantt-chart.js';

type Context = {
  segmentsData: GanttSegmentData[];
  parentSegmentsData?: GanttSegmentData[];
  config: DataTableV2GanttColumnConfig;
  hovering?: boolean;
  segmentScale?: ScaleLinear<number, number, never>;
};

export const GanttSegmentsContext = createContext<Context>({
  segmentsData: [],
  parentSegmentsData: undefined,
  config: { nameAccessor: 'name' },
  hovering: false,
});

export const useGanttSegmentsContext = (): Context =>
  useContext(GanttSegmentsContext);

GanttSegmentsContext['displayName'] = 'ganttSegmentsContext';
